var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "toolbar bg-gray-900" }, [
    _c("div", { staticClass: "container py-2" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("ncc-toolbar-icon", {
            class: { "button--disabled": !_vm.qna.prev },
            attrs: { icon: "ncc-arrow-left" },
            on: {
              click: function($event) {
                return _vm.goto("prev")
              }
            }
          }),
          _vm._v(" "),
          _c("ncc-toolbar-icon", {
            class: { "button--active": _vm.isTabVideobarActive },
            attrs: { icon: "ncc-camera" },
            on: { click: _vm.showVideobar }
          }),
          _vm._v(" "),
          _c("ncc-toolbar-icon", {
            class: { "button--active": _vm.isTabNotesActive },
            attrs: { icon: "ncc-notes" },
            on: { click: _vm.showNotes }
          }),
          _vm._v(" "),
          _c("ncc-toolbar-icon", {
            class: { "button--active": _vm.isTabPrayerActive },
            attrs: { icon: "ncc-chat" },
            on: { click: _vm.showPrayer }
          }),
          _vm._v(" "),
          _c("ncc-toolbar-icon", {
            class: { "button--disabled": !_vm.qna.next },
            attrs: { icon: "ncc-arrow-right" },
            on: {
              click: function($event) {
                return _vm.goto("next")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }